
import { defineComponent, ref } from 'vue';

import FormularioVeiculo from "./forms/veiculos/FormularioVeiculo.vue";

import VeiculosTable from "./components/VeiculosTable.vue";

import fintailapi from "../api";

export default defineComponent({
  name: "tables",
  components: {
    VeiculosTable,
    FormularioVeiculo
  },
  data() {
    return {
      rows: [],
      operacoes: [],
      veiculo:{id:"-"},
      current_page: 0,
      total_count: 0,
      total_pages: 0,
    };
  },
  methods: {
    getOperacoes(offset:number) {

      fintailapi
      .get(`/operacoes?offset=${offset}&limit=100&ativas=true`)
      .then((response:any) => {
        this.operacoes = response.data.rows
      })
      .catch((error:any) => {

      })

    },
    getVeiculo(id:any) {

      fintailapi
        .get(`/veiculos/${id}`)
        .then((response:any) => {
          this.veiculo = response.data
        })
        .catch((error:any) => {

        })

    },
    getVeiculos(offset:number) {

        fintailapi
        .get(`/veiculos?offset=${offset}&limit=10`)
        .then((response:any) => {

          this.current_page = offset;
          this.total_count = response.data.count
          this.total_pages =  Math.ceil(response.data.count / 10);
          this.rows = response.data.rows

          this.getOperacoes(0)
        
        })
        .catch((error:any) => {

        })

    },
    salvarVeiculo(veiculo:any) {

      if(veiculo.id != '' && veiculo.id != undefined){

        fintailapi
        .put(`/veiculos/${veiculo.id}`, veiculo)
        .then((response:any) => {
          
          this.veiculo.id = "-"
          this.getVeiculos(0)

        })
        .catch((error:any) => { })

      }else{
        veiculo.id = undefined
        fintailapi
        .post(`/veiculos`, veiculo)
        .then((response:any) => {
          
          this.veiculo.id = "-"
          this.getVeiculos(0)

        })
        .catch((error:any) => {  })
      }
    },
    fecharVeiculo() {

      this.veiculo.id = "-"

    },
   },
   created() {
    
    let modo = this.$route.params.id ||'view';

    if(modo=="criar"){
      this.veiculo.id = ""
    }

      this.getVeiculos(0)


    },

});


